import { RouterProvider } from "react-router";

import router from "@/Router";
import "@/App.css";
import "@/ButtonStyling.css";

function App() {
  return <RouterProvider router={router} />;
}

export default App;
